import { MenuItem, Tooltip } from "@biom3/react";
import Image from "next/image";
import { useTranslation } from "react-i18next";

import { walletIconProps } from "@/components/wallets/utils/walletIconParams";
import type { Wallet } from "@/types";
import { toSimpleAddressFormat } from "@/utils/util";

type LinkWalletItemProps = {
  wallet: Wallet;
  onNicknameOpenModal: (wallet: Wallet) => void;
  onUnlinkOpenModal: (wallet: Wallet) => void;
};

const LinkedWalletItem = ({
  wallet,
  onNicknameOpenModal,
  onUnlinkOpenModal,
}: LinkWalletItemProps) => {
  const { alt, sx, imagePath, testId } = walletIconProps(wallet.type);
  const { t } = useTranslation();
  return (
    <MenuItem
      testId="linked-wallets-menu-item"
      key={wallet.address}
      emphasized
      size="small"
      sx={{
        width: "100%",
      }}
    >
      <MenuItem.FramedImage
        {...{ testId, sx }}
        use={<Image alt={alt} src={imagePath} />}
      />
      {wallet.name ? (
        <MenuItem.Label testId="linked-wallets-menu-item-label-name">
          {wallet.name}
        </MenuItem.Label>
      ) : (
        <MenuItem.Label testId="linked-wallets-menu-item-label-address">
          {toSimpleAddressFormat(wallet.address)}
        </MenuItem.Label>
      )}
      {wallet.name && (
        <MenuItem.Caption testId="linked-wallets-menu-item-caption">
          {toSimpleAddressFormat(wallet.address)}
        </MenuItem.Caption>
      )}
      <Tooltip>
        <Tooltip.Target>
          <MenuItem.StatefulButtCon
            testId="linked-wallets-menu-item-stateful-buttcon-edit"
            icon="Edit"
            onClick={() => onNicknameOpenModal(wallet)}
          />
        </Tooltip.Target>
        <Tooltip.Content>{t("nickname")}</Tooltip.Content>
      </Tooltip>
      <Tooltip>
        <Tooltip.Target>
          <MenuItem.StatefulButtCon
            testId="linked-wallets-menu-item-stateful-buttcon-disconnect"
            icon="WalletDisconnect"
            onClick={() => onUnlinkOpenModal(wallet)}
          />
        </Tooltip.Target>
        <Tooltip.Content>{t("unlink")}</Tooltip.Content>
      </Tooltip>
    </MenuItem>
  );
};

export { LinkedWalletItem };
